import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import { getErrorAsList } from "../utils";

const initialState = {
  loading: false,
  error: undefined,
  projectList: [],
};

export const clearErrorProject = createAction("projects/clearErrorProject");

export const getAllProjects = createAsyncThunk("projects/getAllProjects", async (args, thunkAPI) => {
  try {
    const { data } = await api.get("/api/projects/");
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const insertProject = createAsyncThunk("projects/insertProject", async (args, thunkAPI) => {
  try {
    const body = { name: args.name };
    const { data } = await api.post("/api/projects/", body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const projectSlice = createSlice({
  name: "project",
  initialState,
  extraReducers: {
    // Clear error (if any)
    [clearErrorProject]: (state) => {
      state.error = undefined;
    },

    // Get all
    [getAllProjects.pending]: (state) => {
      state.loading = true;
    },
    [getAllProjects.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.projectList = action.payload;
    },
    [getAllProjects.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Insert
    [insertProject.pending]: (state) => {
      state.loading = true;
    },
    [insertProject.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.projectList.push(action.payload);
    },
    [insertProject.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default projectSlice.reducer;
